import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { Grid, Typography, Tabs, Tab } from '@mui/material';
import LCInfo from './LCInfo';
import LCMembers from './LCMembers';
import LCLeadership from './LCLeadership';
import LCCommittees from './LCCommittees';
import LCSocial from './LCSocial';
import LCResources from './LCResources';
import { useApiGet } from '../../../utils/httpClient';
import { getLCDetail } from '../../../endpoints/chapters';

const LCDetail = () => {
  let { id } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = useCallback(
    (key, value) => {
      if (!value || value === '') {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  const convertTextToTabIndex = (text) => {
    switch (text) {
      case 'info':
        return 0;
      case 'leadership':
        return 1;
      case 'members':
        return 2;
      case 'committees':
        return 3;
      case 'social':
        return 4;
      case 'resources':
        return 5;
      default:
        return 0;
    }
  };
  const { data } = useApiGet(
    ['lc-chapters-detail', id],
    getLCDetail,
    {
      enabled: true,
      retry: 1,
    },
    {
      id: id,
    }
  );

  const [tabSelected, setTabSelected] = useState(
    searchParams.get('tab') ? convertTextToTabIndex(searchParams.get('tab')) : 0
  );

  const converTabIndexToText = (index) => {
    switch (index) {
      case 0:
        return 'info';
      case 1:
        return 'leadership';
      case 2:
        return 'members';
      case 3:
        return 'committees';
      case 4:
        return 'social';
      case 5:
        return 'resources';
      default:
        return '';
    }
  };

  useEffect(() => {
    updateSearchParams('tab', converTabIndexToText(tabSelected));
  }, [tabSelected, updateSearchParams]);

  return (
    <Grid container>
      <Grid item xs={12} padding textAlign={'center'}>
        {data?.is_disbanded ? (
          <Typography variant="h4" color="error">
            {data?.name} (Disbanded)
          </Typography>
        ) : (
          <Typography variant="h4">{data?.name}</Typography>
        )}
      </Grid>
      <Grid item xs={12} padding>
        <Tabs
          value={tabSelected}
          onChange={(event, newValue) => setTabSelected(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Chapter Info" />
          <Tab label="Chapter Leadership" />
          {data?.local_chapter_access && <Tab label="Chapter Members" />}
          {data?.local_chapter_access && <Tab label="Chapter Committees" />}
          {data?.local_chapter_access && <Tab label="Social Information" />}
          {data?.local_chapter_access && <Tab label="Chapter Resources" />}
        </Tabs>
      </Grid>
      <Grid item xs={12} padding>
        {tabSelected === 0 && (
          <LCInfo id={id} lcAccess={data?.local_chapter_access} />
        )}
        {data?.local_chapter_access && tabSelected === 2 && (
          <LCMembers
            id={id}
            lcAccess={data?.local_chapter_access}
            lcAction={data?.local_chapter_action}
          />
        )}
        {tabSelected === 1 && (
          <LCLeadership id={id} lcAccess={data?.local_chapter_access} />
        )}
        {data?.local_chapter_access && tabSelected === 3 && (
          <LCCommittees id={id} lcAccess={data?.local_chapter_access} />
        )}
        {data?.local_chapter_access && tabSelected === 4 && (
          <LCSocial id={id} lcAccess={data?.local_chapter_access} />
        )}
        {data?.local_chapter_access && tabSelected === 5 && (
          <LCResources
            id={id}
            lcAccess={data?.local_chapter_access}
            lcAction={data?.local_chapter_action}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default LCDetail;
